import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 7l-5 5l5 5","key":"svg-0"}],["path",{"d":"M17 7l-5 5l5 5","key":"svg-1"}]]

const IconChevronsLeft = createReactComponent('outline', 'chevrons-left', 'ChevronsLeft', __iconNode);

export default IconChevronsLeft;